
















































import Vue from "vue";
import { Auth } from "@/@core";

export default Vue.extend({
  data() {
    return { drawer: true };
  },
  computed: {
    isOnlyCitizen(): boolean {
      return Auth.isInRole(`CITIZEN`) && !Auth.isInRole(`SUPPORT`) && !Auth.isInRole(`DOCUMENT_ADMIN`) && !Auth.isInRole(`PAYER`);
    },
  },
});
